// libs
import { useSelector, useDispatch } from "react-redux";

// hooks
import useToken from "./useToken";

// utils
import API from "../utils/api";

// slice actions
import {
  setDataAction,
  updateAppDataAction,
} from "../store/slices/appData.slice";

export default function useAppData() {
  const { appData } = useSelector((s) => s.appDataSlice);
  const [token] = useToken();
  const dispatch = useDispatch();

  const getAppData = async () => {
    const result = await API.getToken("/appdata", token);
    if (result.status === 200) {
      dispatch(setDataAction(result.data.appData));
    }
  };

  const updateBalance = (amount) => {
    dispatch(
      updateAppDataAction({
        key: "balance",
        value: appData.balance + Number(amount),
      }),
    );
  };

  return { appData, getAppData, updateBalance };
}
